import {History} from '../../../graphql-typings/graphql';
import {FunctionName} from './chart-function-types';
import {AbstractFunction} from './abstract-function';

export abstract class SimpleFunction extends AbstractFunction {

  protected constructor(name: FunctionName, longNameKey: string) {
    super(name, longNameKey);
  }

  protected applySimpleFunction(functionPtr: (a: number) => number, historyArray: History[]): History[] {
    if (historyArray && historyArray.length) {
      return historyArray.map(history => {
        return {
          fav_id: history.fav_id,
          data: functionPtr(history.data),
          ts: history.ts.clone()
        };
      });
    } else {
      return [];
    }
  }
}
